import createAnimationWrapper from "./createAnimationWrapper";

const anim = {
 '0%': {
  opacity:1
 },
 '100%': {
  opacity:0
 }
};

export default createAnimationWrapper(anim, {
    duration: "1s",
    easing: `cubic-bezier(0.2057,0.573,0.3723,0.9184)`,
    loop: true,
    direction: "alternate",
});

